import _ from 'lodash'

/**
 * useIdToFindResourceList，由于一开始是使用 prefix 去交换资源，但是接口变动 prefix 不准确，改成 id，函数名未修改
 * @param {{resource: Object, id: Number|String}} param0 id: 分类 id
 */
export default function useIdToFindResourceList({
  resource,
  id
}) {
  const list = _.get(resource, id)
  return _.cloneDeep(list)
}
